export default __webpack_public_path__ + "assets/audio/ssml/voicery-speaker.9d6a77069f6217584ce1524223d0e967.mp3";